<template>
  <div class="SnackbarWrapper">
    <div class="snackbar" :class="config.class">
      <div class="content">
        <component :is="component" v-bind="config.props" @use="handle_action" />
      </div>
      <i class="fas fa-times" :class="config.class" @click="destroy" />
    </div>
  </div>
</template>

<script>
import snackbar_default_template from "~/components/shared/snackbar/defaultTemplate"

export default {
  props: {
    config: {
      type: Object,
      required: true,
    },
  },
  computed: {
    component: function () {
      const component = this.config.component || snackbar_default_template

      return {
        ...component,
        mixins: [{ ...this.config.hooks }],
      }
    },
  },
  methods: {
    handle_action: function () {
      if (typeof this.config.callbacks.use === "function")
        this.config.callbacks.use()
    },
    destroy: function () {
      if (typeof this.config.callbacks.close === "function")
        this.config.callbacks.close()

      this.$store.dispatch("snackbar/REMOVE", {
        method: "BY_ID",
        id: this.config.id,
      })
    },
  },
}
</script>

<style scoped src="~/components/notificationSpace/snackbar.css"></style>
<style scoped src="~/components/notificationSpace/snackbar720.css"></style>
<style scoped>
.SnackbarWrapper {
  position: relative;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
}

.snackbar {
  width: calc(100vw - 40px);
  max-width: 584px;
  background-color: var(--color-black);
  box-shadow: 0 1px 3px 0 var(--color-masala-grey);
  border-radius: 3px;
  margin-bottom: 20px;
  padding: 12px 18px 12px 18px;
  display: flex;
  justify-content: flex-start;
}

.content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
}

.fa-times {
  margin-top: 8px;
  font-size: var(--font-size-nano);
  color: var(--color-white);
  cursor: pointer;
}

span {
  color: var(--color-white);
}

@media screen and (max-width: 720px) {
  .snackbar {
    max-width: unset;
  }
}
</style>
